(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('MessagesPortalReportService', MessagesPortalReportService);

  MessagesPortalReportService.$inject = ['$resource'];

  function MessagesPortalReportService ($resource) {
    return $resource('', {}, {
      getMessagesPortal: { url: apiUrl + '/messages-portal/report', method: 'GET', params: {}, isArray: false }
    });
  }
})();
